import Users from "./container";
import withContext from "../../tools/withContext";

export default withContext(Users);
